import React from "react";
import styles from "./A23PlayerAvatar.module.css";
import WinnerLottie from "../../WinnerLottie/WinnerLottie";
import gameAssets from "@themed-assets";
import usePlayerStats from "@/src/hooks/data/usePlayerStats";
import usePlayerDetails from "@/src/hooks/data/usePlayerDetails";

const A23PlayerAvatar = ({
  tempTableId,
  position,
  isFolded,
  isSeatedOut,
  isInactive,
  isWinner,
  isWinnerDeclared,
  winningPotDisplay,
  multiPotAmounts,
  tableTimer,
  userName,
}) => {
  const { openPlayerStats } = usePlayerStats(tempTableId);
  const playerDetails = usePlayerDetails();

  const handleAvatarClick = (event) => {
    event.stopPropagation(); // Prevent click from bubbling up to the parent
    if (userName === playerDetails?.userName) {
      openPlayerStats();
    }
  };

  const returnPlayerAvatar = () => {
    switch (position) {
      case 0:
        return gameAssets.lion;
      case 1:
        return gameAssets.fox;
      case 2:
        return gameAssets.owl;
      case 3:
        return gameAssets.polarbear;
      case 4:
        return gameAssets.crocodile;
      case 5:
        return gameAssets.shark;
      default:
        return gameAssets.lion;
    }
  }

  return (
    <div
      className={`${styles.playerAvatar} ${isFolded || isSeatedOut || isInactive ? styles.folded : ""} ${tableTimer ? styles.activePlayerShadow : ""
        }`}
      onClick={handleAvatarClick}
    >
      <div className={styles.mask}></div>
      <WinnerLottie
        tempTableId={tempTableId}
        isWinner={isWinner}
        isWinnerDeclared={isWinnerDeclared}
        winningPotData={winningPotDisplay}
        multiPotAmounts={multiPotAmounts}
      />
      <img src={returnPlayerAvatar()} alt='Player Avatar' />
    </div>
  );
};

export default A23PlayerAvatar;
